import { getCommunityData } from "firebase_/firebase_function/firebase_community";
import { getBlockData } from "firebase_/firebase_function/firebase_user";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "util/context/user_context";

const NewCommunityStory = () => {
  const [communityList, setCommunityList] = useState([]);
  const { userData } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    fetchLatest();
  }, []);

  const fetchLatest = async () => {
    try {
      const blockData = userData?.docId ? await getBlockData(userData.docId) : null;
      const response = await getCommunityData("", 5, null, blockData);
      if (response) setCommunityList(response);
    } catch (e) {
      // ignore
    }
  };

  if (!communityList || communityList.length === 0) {
    return (
      <div style={{ padding: "24px 0", color: "#6B7280", fontSize: 14, textAlign: "center" }}>
        작성된 글이 없습니다.
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {communityList.slice(0, 5).map((item, index, arr) => (
        <div
          key={item.docId ?? index}
          onClick={() => navigate(`/community/${item.docId}`)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "14px 0",
            borderBottom: index !== arr.length - 1 ? "1px solid #F3F4F6" : "none",
            cursor: "pointer",
            gap: 12,
          }}
        >
          <div
            style={{
              fontSize: 14,
              color: "#111827",
              fontWeight: 500,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
            }}
          >
            {item.title}
          </div>
          <div style={{ fontSize: 12, color: "#9CA3AF", whiteSpace: "nowrap" }}>
            {moment(item.createDate).format("YYYY.MM.DD")}
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewCommunityStory;
